import React, { useState } from 'react';
import { View, Text, StyleSheet, Image, Button, Alert } from 'react-native';
import Amplify, { Auth, MemoryStorage, Storage } from 'aws-amplify';
import { SafeAreaView } from 'react-native-safe-area-context';
import EStyleSheet from 'react-native-extended-stylesheet';
import LoginButtonInput from '../components/LoginButtonInput';
import LoginButton from '../components/LoginButton';
import ResetPasswordButton from '../components/ResetPasswordButton';
//import CreateAccount from './CreateAccount';
import CreateAccountButton from '../components/CreateAccountButton';
import mainIcon from '../assets/uploadifierSymbol.png';
import ResetPassword from './ResetPassword';



export default function Login({ navigation, updateAuthState }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function login() {
    try {

      
      await Auth.signIn(username, password);
      console.log('Authentication Success, User has logged in properly');
      updateAuthState('loggedIn');
      
  

    } catch (error) {
      console.log(' Error signing in...', error);

      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        if (error.name === 'AuthError'){
          Alert.alert('You need to enter your user email to login please.')
        }
      }
      if (Platform.OS === 'web'){
        if (error.name === 'AuthError'){
        alert('You need to enter your user email to login please.')
        }
      }

      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        if (error.name === 'NotAuthorizedException'){
          Alert.alert('Use the reset password button if needed.')
          Alert.alert('Bad Login, please verify that your login and password are correct and retry.')
          console.log('sign in failure not authorized')
        }
      }
      if (Platform.OS === 'web'){
        if (error.name === 'NotAuthorizedException'){
        alert('Bad Login, please verify that your login and password are correct and retry.')
        alert('Use the reset password button if needed.')
        console.log('sign in failure not authorized')
        }
      }

      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        if (error.name === 'InvalidParameterException'){
          Alert.alert('Use the reset password button if needed.')
          Alert.alert('Bad Login, please verify that your login and password are correct and retry.')
        }
      }
      if (Platform.OS === 'web'){
        if (error.name === 'InvalidParameterException'){
        alert('Bad Login, please verify that your login and password are correct and retry.')
        alert('Use the reset password button if needed.')
        }
      }
    }
  }
  return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <Text style={styles.title}>Help take back your part of the internet</Text>
        <Text>You no longer have to shrug off unwanted pics and comments. We send the offensive content you upload to a portal searchable by HR departments for them to take action</Text>

        <LoginButtonInput
          value={username}
          onChangeText={text => setUsername(text)}
          leftIcon="account"
          placeholder="Enter username"
          autoCapitalize="none"
          keyboardType="email-address"
          textContentType="emailAddress"
        />
        <LoginButtonInput
          value={password}
          onChangeText={text => setPassword(text)}
          leftIcon="lock"
          placeholder="Enter password"
          autoCapitalize="none"
          autoCorrect={false}
          secureTextEntry
          textContentType="password"
        />
        <LoginButton title="Login" onPress={login}/>
        <View style={styles.footerButtonContainer}> 
          
            <Text style={styles.forgotPasswordButtonText}>
              Don't have an account? Click below to create one for free!
            </Text>
          

        </View>

        <CreateAccountButton title="Create Account" onPress={() => navigation.navigate('CreateAccount')} />
        <View style={styles.footerButtonContainer}> 
        </View>

        <ResetPasswordButton title="Reset Password" onPress={() => navigation.navigate('ResetPassword')}/>
        <View style={styles.footerButtonContainer}> 
        </View>
       
        <Image source={mainIcon} style={{ width: '75%', height: '50%', resizeMode: 'contain', }} />
      </View>
     
    </SafeAreaView>

    
  );
}

const styles = EStyleSheet.create({
      safeAreaContainer: {
        flex: 1,
        backgroundColor: 'white'
      },
      container: {
        flex: 1,
        alignItems: 'center'
      },
      title: {
        fontSize: 20,
        color: '#202020',
        fontWeight: '500',
        marginVertical: '1rem',
        justifyContent: 'center',
        alignItems: 'center'
      },
      footerButtonContainer: {
        marginVertical: '1rem',
        justifyContent: 'center',
        alignItems: 'center'
      },
      forgotPasswordButtonText: {
        color: 'black',
        fontSize: '1rem',
        fontWeight: '600'
      }
    });